export class ContactsJourneyInfoModalControler {
    static $inject = ['close'];
    constructor(close) {
        this.close = close;
        this._close = this.close;
    }
    confirm() {
        this._close(true);
    }
}
ContactsJourneyInfoModalControler.$inject = ['close'];
